import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { isPossiblePhoneNumber } from 'libphonenumber-js/min';

// Validator to check if the inputted phone number is valid
export function validatePhoneFormat(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const isPossible = control.value ? isPossiblePhoneNumber(control.value, 'US') : true;
        return isPossible ? null : { phoneFormat: true };
    };
}
